module.exports = __webpack_public_path__ + "media/images/timetable-image-d97bd6fd29bee1e58a8edfac8ad6883a.jpg";